export enum ServiceRequestStatus {
  New = '1',
  InProgress = '2',
  Completed = '3',
  Canceled = '4',
  Draft = '5',
  NewCP = '6'
}
